import { connect } from 'react-redux';
import { getDuperbrowseNavigation } from '../../../Duperbrowse/redux/selectors';
import { movePrev, moveNext } from '../../../Duperbrowse/redux/actionCreators';
import { getIsDuperbrowseAllowed } from '../../../DeviationPage/redux/selectors';
var mapStateToProps = function (state) { return ({
    isEnabled: getIsDuperbrowseAllowed(state),
    navigation: getDuperbrowseNavigation(state),
}); };
var mapDispatchToProps = {
    moveNext: moveNext,
    movePrev: movePrev,
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=Duperswiper.container.js.map